import {createSelector} from 'reselect';

import {AppState} from '../../../../../verticals/hotels-dweb/src/shared/store';

export const ugcUnifSelector = (state: AppState) => state.ugcUnif;
export const detailsUnifSelector = (state: AppState) => state.detailsUnif;

export const ugcReviewDataSelector = createSelector(ugcUnifSelector, ugcUnif => ugcUnif?.review);

export const ugcReviewListSelector = createSelector(
  ugcReviewDataSelector,
  reviewData => reviewData?.reviews?.reviewList,
);

export const ugcSummarySelector = createSelector(
  detailsUnifSelector,
  details => details?.static?.ugcSummary,
);

export const sortingCriterionListSelector = createSelector(
  ugcSummarySelector,
  ugcSummary => ugcSummary?.sortingCriterionList || [],
);

export const selectedGalleryTabSelector = createSelector(
  ugcUnifSelector,
  ugcUnifData => ugcUnifData?.selectedGalleryTab,
);
